import React from 'react';
import './style.css';

const TechTags = ({ items = [], label = 'Built with', className = '' }) => {
    if (!items.length) {
        return null;
    }

    return (
        <div className={`tech-tags ${className}`.trim()}>
            <p className="eyebrow2">{label}</p>
            <ul className="tech-tag-list">
                {items.map((item) => (
                    <li className="tech-tag" key={item}>{item}</li>
                ))}
            </ul>
        </div>
    );
};

export default TechTags;
